import { AgentDesktopRouter } from '@agent/agent-interface/agent-desktop-router';
import { AgentDesktopRouteParams } from '@agent/agent-interface/agent-desktop-routing.module';
import { Component, Directive, ElementRef, Injector, Input } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

import { default as componentAjs } from './agent-booking-phone-qualification.component.ajs';

@Directive({
  selector: 'cng-agent-booking-phone-qualification-upgrade',
})
export class AgentBookingPhoneQualificationUpgradeComponent extends UpgradeComponent {
  @Input() responseId: string;

  constructor(elementRef: ElementRef, injector: Injector) {
    super(componentAjs, elementRef, injector);
  }
}

@Component({
  selector: 'cng-agent-booking-phone-qualification',
  template:
    '<cng-agent-booking-phone-qualification-upgrade [responseId]="responseId$ | async"></cng-agent-booking-phone-qualification-upgrade>',
})
export class AgentBookingPhoneQualificationComponent {
  readonly responseId$ = this.router.currentSnapshot$.pipe(AgentDesktopRouteParams.ResponseId.select);

  constructor(private readonly router: AgentDesktopRouter) {}
}
